import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';

export default class SpeakersList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			junior_speakers: [],
			senior_speakers: [],
			devops_speakers: [],
		};
	}

	componentDidMount() {
		fetch(
			'https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1711724252528x137297889172914180'
		)
			.then(res => res.json())
			.then(json => {
				this.setState({
					junior_speakers: json,
				});
			});

		fetch(
			'https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1711724257670x920005253968429000'
		)
			.then(res => res.json())
			.then(json => {
				this.setState({
					senior_speakers: json,
				});
			});
		
		fetch(
			'https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1729521081537x685766542004322300'
		)
			.then(res => res.json())
			.then(json => {
				this.setState({
					devops_speakers: json,
				});
			});
	}

	render() {
		return (
			<div className='speakers' id='speakers'>
				<VideoPresent
					speakersJunior={this.state.junior_speakers}
					speakersSenior={this.state.senior_speakers}
					speakersDevops={this.state.devops_speakers}
				/>
			</div>
		);
	}
}
